export default {
    // Header
    brand: 'PlayCatGames',
    nav: {
        home: 'Главная',
        games: 'Игры',
        categories: 'Категории',
        about: 'О нас'
    },
    search: {
        placeholder: 'Поиск игр с кошками...'
    },

    // Hero Section
    hero: {
        title: 'Игры с Кошками',
        description: 'Игры с кошками на PlayCatGames позволяют играть, ухаживать и взаимодействовать с виртуальными кошками различными забавными и умными способами. Вы можете кликать или нажимать, чтобы бросать игрушки по экрану, перетаскивать наряды на персонажа или использовать быстрые рефлексы для ловли рыбы и погони за наградами.',
        subtitle: 'Некоторые игры с кошками проверяют время реакции во время прыжков, бега или лазания, в то время как другие сосредоточены на простых действиях, таких как кормление, уход или нажатие для получения очков. Каждая игра создана для мгновенного веселья в вашем браузере. Без установок. Без загрузок. Просто мяу!',
        buttons: {
            start: 'Начать Играть',
            browse: 'Просмотреть Категории'
        },
        stats: {
            games: 'Бесплатные Игры',
            categories: 'Категории Игр',
            free: 'Бесплатный Опыт',
            available: 'Всегда Доступно'
        }
    },

    // Games Section
    games: {
        title: 'Популярные Игры с Кошками',
        subtitle: 'Откройте для себя самые популярные бесплатные онлайн-игры с кошками для игроков всех возрастов',
        filters: {
            all: 'Все',
            dressUp: 'Одевалки',
            care: 'Уход',
            puzzle: 'Головоломки',
            arcade: 'Аркады',
            simulation: 'Симуляторы'
        },
        loadMore: 'Загрузить Больше Игр',
        gameCategories: {
            arcade: 'Аркады',
            simulation: 'Симуляторы',
            care: 'Уход',
            puzzle: 'Головоломки',
            dressUp: 'Одевалки'
        }
    },

    // Categories Section
    categories: {
        title: 'Категории Игр',
        subtitle: 'Каждая игра с кошками построена вокруг деятельности, которая больше всего нравится игрокам: стилизация, уход за питомцами или бег по забавным трассам',
        browse: 'Просмотреть Категорию',
        featuredGames: 'Рекомендуемые Игры',
        gameCount: 'Игр',
        types: {
            dressUp: {
                name: 'Игры-Одевалки с Кошками',
                description: 'Игры-одевалки с кошками дают волю вашему творчеству. Смешивайте наряды, добавляйте аксессуары и открывайте тематические образы от фантазийных наборов до сезонного снаряжения.'
            },
            simulation: {
                name: 'Симуляция и Ролевые Игры с Кошками',
                description: 'В играх-симуляторах вы встаете на лапы кошки. Бродите, исследуйте и живите любопытной жизнью котенка.'
            },
            puzzle: {
                name: 'Управление Кошками и Игры-Головоломки',
                description: 'Для любителей стратегии игры-головоломки и управление кошками предлагают умные повороты. Балансируйте несколько кошек, решайте сложные задачи по укладке.'
            },
            arcade: {
                name: 'Аркадные и Экшн Игры с Кошками',
                description: 'Быстрые аркадные игры с кошками, которые проверяют ваши рефлексы и ловкость. Прыгайте, бегайте, ловите и наслаждайтесь захватывающими игровыми впечатлениями.'
            }
        },
        additional: {
            title: 'Исследуйте Больше Типов Игр с Кошками',
            description: 'Наша коллекция игр с кошками охватывает каждое настроение и предпочтение: модные игры, уход за питомцами, сложные головоломки или забавные аркадные забеги. Наши браузерные игры с кошками бесплатны, безопасны и готовы к игре за секунды.',
            motto: 'Просто выберите игру, нажмите старт и позвольте веселью ожить!'
        }
    },

    // About Section
    about: {
        title: 'О PlayCatGames',
        description: [
            'PlayCatGames - это ваше идеальное место для исследования удивительного мира игр с кошками. Мы тщательно подобрали коллекцию бесплатных онлайн-игр с кошачьей тематикой, подходящих для игроков всех возрастов.',
            'От милых игр-одевалок до захватывающих аркадных приключений, от теплых симуляторов ухода до умных головоломок - наша коллекция игр охватывает все, что могут пожелать любители кошек. Все игры тщательно отобраны для обеспечения лучшего игрового опыта.',
            'Мы верим, что игры должны быть мгновенными, веселыми и легко доступными. Поэтому все наши игры могут работать прямо в вашем браузере без загрузки или установки программного обеспечения. Просто кликните и начинайте играть!'
        ],
        features: {
            free: '100% Бесплатные Игры',
            mobile: 'Совместимо с Мобильными',
            instant: 'Мгновенная Игра',
            safe: 'Безопасно и Надежно'
        },
        faq: {
            title: 'Часто Задаваемые Вопросы',
            questions: {
                free: {
                    q: 'Эти игры действительно бесплатны?',
                    a: 'Да! Все наши игры с кошками полностью бесплатны. Вам не нужно ничего платить, чтобы наслаждаться всем игровым контентом.'
                },
                download: {
                    q: 'Нужно ли скачивать какое-либо программное обеспечение?',
                    a: 'Нет! Все игры могут работать прямо в вашем браузере. Просто кликните на игру, чтобы начать играть, никаких загрузок или установок не требуется.'
                },
                age: {
                    q: 'Для какой возрастной группы подходят эти игры?',
                    a: 'Наши игры с кошками подходят для игроков всех возрастов. От простых игр-одевалок до сложных головоломок - каждый может найти подходящие игры.'
                },
                mobile: {
                    q: 'Поддерживают ли игры мобильные устройства?',
                    a: 'Да! Все наши игры оптимизированы для идеальной работы на ПК, планшетах и телефонах. Вы можете наслаждаться играми в любое время и в любом месте.'
                },
                updates: {
                    q: 'Будете ли вы добавлять новые игры?',
                    a: 'Абсолютно! Мы регулярно обновляем нашу библиотеку игр и добавляем новые интересные игры с кошками. Пожалуйста, возвращайтесь почаще, чтобы узнать о новейшем игровом контенте.'
                }
            }
        }
    },

    // Footer
    footer: {
        description: 'Ваше место назначения для коллекции бесплатных онлайн-игр с кошками. Открывайте, играйте и наслаждайтесь десятками захватывающих игр с кошачьей тематикой.',
        quickLinks: 'Быстрые Ссылки',
        gameCategories: 'Категории Игр',
        support: 'Поддержка',
        links: {
            popularGames: 'Популярные Игры',
            latestGames: 'Последние Игры',
            recommendedGames: 'Рекомендуемые Игры',
            faq: 'Часто Задаваемые Вопросы',
            contact: 'Связаться с Нами',
            feedback: 'Обратная Связь',
            privacy: 'Политика Конфиденциальности',
            terms: 'Условия Обслуживания',
            cookies: 'Политика Файлов Cookie',
            sitemap: 'Карта Сайта'
        },
        copyright: 'Все права защищены.',
        disclaimer: 'Весь игровой контент получен из интернета исключительно для развлекательных и образовательных целей. Пожалуйста, свяжитесь с нами, если есть проблемы с авторскими правами.',
        backToTop: 'Наверх',
        friendlyLinks: 'Дружественные Сайты'
    },

    // Game Data
    gameData: {
        descriptions: {
            kittyLovesBirds: 'Помогите котенку поймать летающих птиц и покажите свою скорость реакции',
            catPizza: 'Управляйте кошачьей пиццерией и делайте вкусную пиццу для клиентов',
            funnyKittyCare: 'Ухаживайте за милыми котятами, кормите их, купайте и играйте',
            catsDrop: 'Игра по укладке кошек, которая проверяет ваши навыки баланса и стратегии',
            catpad: 'Милая игра-платформер с прыгающими кошками',
            funnyKittyDressup: 'Одевайте милых котят в различную одежду и аксессуары',
            kittyCats: 'Казуальная игра для взаимодействия с несколькими милыми кошками',
            dualCat: 'Игра-вызов, управляющая двумя кошками одновременно',
            funnyKittyHaircut: 'Игра красоты, создающая модные прически для котят',
            catCoffeeShop: 'Управляйте кошачьим кафе и готовьте вкусные напитки'
        },
        categories: {
            puzzle: 'Головоломка',
            simulation: 'Симуляция',
            casual: 'Казуальная',
            action: 'Экшн',
            adventure: 'Приключения',
            strategy: 'Стратегия',
            sports: 'Спорт',
            racing: 'Гонки',
            dressup: 'Одевалки',
            care: 'Уход'
        },
        tags: {
            cute: 'Милые',
            anime: 'Аниме',
            dark: 'Темные',
            funny: 'Смешные',
            educational: 'Образовательные',
            multiplayer: 'Многопользовательские',
            relaxing: 'Расслабляющие',
            challenging: 'Сложные',
            colorful: 'Красочные',
            simple: 'Простые',
            complex: 'Сложные',
            family: 'Семейные',
            kids: 'Детские',
            adult: 'Взрослые'
        }
    },

    // Common
    common: {
        loading: 'Загрузка...',
        error: 'Что-то пошло не так',
        retry: 'Повторить',
        play: 'Играть',
        language: 'Язык',
        backToHome: 'Вернуться на Главную'
    },

    // Legal Pages (simplified)
    legal: {
        privacy: { title: 'Политика Конфиденциальности', lastUpdated: 'Последнее Обновление' },
        terms: { title: 'Условия Обслуживания', lastUpdated: 'Последнее Обновление' },
        cookies: { title: 'Политика Файлов Cookie', lastUpdated: 'Последнее Обновление' }
    },

    // Sitemap
    sitemap: {
        title: 'Карта Сайта',
        description: 'Найдите все страницы и контент на сайте PlayCatGames'
    }
}